export const masterManagementRouteDef = [
    {
        path: 'cug_location_mapping',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'cug_location_mapping',
            action: 'LIST'
        }
    },

]